import { ProductCategoryType } from '@openeducation/oe-rn-shared-types';

import { LevelsMetadataService } from './levels-metadata.service';
import { StudentLevelsService } from './student-levels.service';
import mapUserAndLevels from './user-levels.mapper';
import { UserProgressService } from './user-progress.service';
import type { UserLevels } from '../interfaces';
import type { Environment } from '../interfaces/environment';

export abstract class UserLevelsService {
  static async getUserLevels(
    env: Environment,
    personId: number,
    contactId: string,
    productCategory?: ProductCategoryType
  ): Promise<UserLevels[]> {
    const progress = await UserProgressService.getUserProgress(env, personId);
    const levelsMetadata = await LevelsMetadataService.getLevelsMetadata(
      env,
      productCategory
    );
    const studentLevels = await StudentLevelsService.getStudentLevels(
      env,
      contactId
    );

    return mapUserAndLevels(progress, levelsMetadata, studentLevels);
  }
}
